<template>
  <div>
    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        :is-full-page="true"
        :z-index="10000000"
        background-color="#000"
        color="#fff"
      ></loading>
    </div>
    <div class="contentArea">
      <div class="pl-2">
        <div>
          <div class="w-full">
            <div class="flex justify-between ml-3 date-filter">
              <div class="flex">
                <!-- <h1
                  v-for="path in folderLevelName"
                  :key="path.folderId"
                  class="text-white"
                  style="cursor: pointer;"
                  @click="goToFolder(path.folderId)"
                >
                  {{ path.name }}
                </h1> -->
                <div
                  class="folder-path"
                  v-for="path in folderLevelName"
                  :key="path.folderId"
                >
                  <h1>&nbsp;{{ path.name }}</h1>
                </div>
              </div>
              <div class="flex">
                <vs-button
                  color="#15c1c3"
                  class="mr-3 px-px"
                  style="width: 140px;"
                  @click="downloadSelected"
                >
                  <font-awesome-icon icon="file-import" class="mr-1" />
                  ดาวน์โหลด
                </vs-button>
                <div class="search flex items-center">
                  <font-awesome-icon
                    icon="search"
                    class="mr-1"
                    :style="{ color: '#03a9f3' }"
                  />
                  <input
                    type="text"
                    placeholder="Search"
                    v-model="searchTerm"
                  />
                </div>
              </div>
            </div>
            <AgGrid :searchQuery="searchTerm" ref="fileTable" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import axios from "axios";
import baseUrl from "../util/backend.js";
import fileUrl from "../util/backendfile.js";
import moment from "moment";
import { mapGetters } from "vuex";
import topTableButton from "../views/elements/topTableButton/topTableButton";
import AgGrid from "./elements/ag-grid-table/AgGridTable";
import AgTable from "../views/elements/ag-grid-table/table_component/tableOnly";
import tabComponent from "./elements/tabComponent/tabComponent";
import boardMain from "./elements/board/boardMain";
export default {
  data() {
    return {
      isLoading: false,
      showDialog: false,
      filterDisplay: false,
      displayCreate: false,
      displayDelete: false,
      displayPermission: false,
      deleteId: null,
      searchTerm: "",
      accountingList: [],
      bankPaymentList: [],
      memberList: [],
      modalCompany: null,
      selectedAccounting: null,
      // for filtering in modal
      monthSelected: 0,
      yearSelected: new Date().getFullYear(),
      // for filtering in filter by
      startDate: null,
      endDate: null,
      // for permission table modal
      modalFolderId: null,
      folderName: "",
      fileType: "",
      roleId: null,
      userToFolder: [],
      roleList: [],
    };
  },
  computed: {
    ...mapGetters({ nowSlug: "getNowSlug", tabActive: "general/tabActive" }),
    formattedStartDate() {
      if (this.startDate) {
        return moment(this.startDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    formattedEndDate() {
      if (this.endDate) {
        return moment(this.endDate).format("DD/MM/YYYY");
      } else {
        return null;
      }
    },
    folderLevelName() {
      return this.$store.getters["create/getFolder"];
    },
  },
  components: {
    topTableButton,
    tabComponent,
    boardMain,
    AgGrid,
    AgTable,
    Loading,
  },
  watch: {
    $route() {
      console.log("route change");
      this.loadUserTable();
    },
    startDate() {
      if (this.endDate) {
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
        }
      }
    },
  },
  methods: {
    toggleDialog() {
      this.showDialog = !this.showDialog;
    },
    closeFilter() {
      this.filterDisplay = false;
    },
    resetFilter() {
      this.startDate = null;
      this.endDate = null;
      this.$store.dispatch("general/getTable", "third");
    },
    getFile(url, title) {
      console.log("url", url);
      axios({
        method: "get",
        url,
        responseType: "arraybuffer",
        // headers: { "Access-Control-Allow-Origin": "*" },
      })
        .then((response) => {
          this.forceFileDownload(response, title);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response, title) {
      console.log(title);
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", title);
      document.body.appendChild(link);
      link.click();
    },
    timeout(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    async downloadSelected() {
      const selectedFile = this.$refs.fileTable.getSelectedRowData();
      console.log(selectedFile);
      // const linkArr = [];
      for await (const select of selectedFile) {
        if (select.type === "File") {
          await this.timeout(500);
          this.getFile(select.file_url, select.name);
        }
        if (select.type === "Folder") {
          for await (const file of select.folder_file) {
            await this.timeout(500);
            this.getFile(file.url, file.name);
          }
        }
      }
    },
    async loadUserTable() {
      this.isLoading = true;
      if (!this.$route.params.id) {
        console.log("don't have folder id");
        await this.$store.dispatch("general/getUserFileTable", {
          path: "tenth",
          userId: this.$store.getters.getUserId,
        });
      } else {
        await this.$store.dispatch("general/getUserFileTable", {
          path: "tenth",
          userId: this.$store.getters.getUserId,
          folderId: this.$route.params.id,
        });
      }
      this.isLoading = false;
    },
    // async loadFolderTable() {
    //   this.isLoading = true;
    //   await this.$store.dispatch("general/getFilteredFolderTable", {
    //     path: "tenth",
    //     folderId: this.$route.params.id,
    //   });
    //   this.isLoading = false;
    // },
    goToFolder(id) {
      const index = this.folderLevelName.findIndex((v) => v.folderId === id);
      console.log("index", index);
      const newLevel = [];
      for (let i = 0; i <= index; i++) {
        newLevel.push(this.folderLevelName[i]);
      }
      this.$store.dispatch("create/skipFolder", newLevel);
      this.$router.replace(`/foldermanagement/${id}`);
    },
    popFolderLevel() {
      this.$store.dispatch("create/popFolderLevelName");
      // if (this.$route.params.id && !this.isLoading) {
      // }
    },
  },
  created() {
    this.loadUserTable();
    this.$store.dispatch("create/setFolderLevelName", {
      name: "All Files",
      folderId: this.$route.params.id,
    });
  },
  mounted() {
    window.addEventListener("popstate", this.popFolderLevel);
  },
  beforeDestroy() {
    window.removeEventListener("popstate", this.popFolderLevel);
  },
  destroyed() {
    this.$store.dispatch("create/clearFolderLevel");
  },
  beforeRouteLeave(_, _2, next) {
    if (this.isLoading) {
      next(false);
    } else {
      next();
    }
  },
};
</script>

<style scoped>
.search input[type="text"] {
  font-size: 17px;
  border: none;
  border-radius: 2px;
  background-color: #3a3f51;
  width: 100px;
  color: #dddddd;
  padding: 10px 5px;
  transition: width 0.5s;
}

.search input[type="text"]:focus {
  width: 300px;
}

.search {
  padding-left: 10px;
  border-radius: 5px;
  border: solid 1.5px #03a9f3;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #03a9f3;
  opacity: 1; /* Firefox */
}

h2,
h4 {
  color: #dddddd;
}

.folder-name {
  border: none;
  border-radius: 2px;
  background-color: #434f5b;
  color: #dddddd;
  width: 122px;
  padding: 8px 10px;
  font-size: 16px;
}

.filter {
  position: absolute;
  right: 0;
  z-index: 1000000;
  background-color: #4e5363;
  width: 20%;
  height: 100vh;
}

.close {
  cursor: pointer;
  margin-top: 8px;
  margin-left: 8px;
  width: 15px;
  height: auto;
}

.filter-header {
  padding: 10px;
  box-shadow: 0 3px 10px 0 rgba(0, 0, 0, 0.09);
}

.filter-input {
  padding: 20px;
}

input[type="button"] {
  height: 34px;
  min-width: 0;
  border-radius: 5px;
  background: #3a3f51;
  border: none;
  color: #ffffff;
  font-size: 17px;
  padding-left: 10px;
}

.right-enter,
.right-leave-to {
  opacity: 0;
  right: -320px;
}

.right-enter-active {
  transition: all 0.3s ease-out;
}

.right-leave-active {
  transition: all 0.3s ease-in;
}

.right-enter-to,
.right-leave {
  opacity: 1;
  right: 0;
}

p {
  color: #fff;
}

select {
  height: 34px;
  border-radius: 2px;
  padding-left: 10px;
  font-size: 16px;
  color: #fff;
  background-color: #434f5b;
  border: none;
}

.pm-table {
  background-color: #4e5363;
  padding: 10px;
  border-radius: 5px;
}

.pm-row {
  overflow-y: scroll;
  height: 200px;
}

.pm-no-row {
  height: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pm-row::-webkit-scrollbar {
  display: none;
}

.table-header {
  padding-bottom: 10px;
  border-bottom: 1px solid #8d9498;
}

.table-row {
  padding: 10px 0;
}

h1 {
  color: #dddddd;
}

.folder-path {
  opacity: 0.5;
}

.folder-path:last-child {
  opacity: 1;
}
</style>
